// extracted by mini-css-extract-plugin
export default {"right":"label-required_right__lWInc","left":"label-required_left__psT2n"};